import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import '../styles/contact.css'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    // Basic frontend form validation
    if (!formDetails.firstName || !formDetails.lastName || !formDetails.email || !formDetails.message) {
        setStatus({ success: false, message: "All fields are required" });
        return;
    }

    if (!validateEmail(formDetails.email)) {
        setStatus({ success: false, message: "Invalid email format" });
        return;
    }

    setFormDetails(formInitialDetails); // Reset form details to initial state

    emailjs
        .sendForm('service_ywnqvxu', 'template_z26srmn', form.current, {
            publicKey: 'Tv1EK7OVMHEx51S5s',
        })
        .then(
            () => {
                setButtonText("Sended");
                setStatus({ success: true, message: 'Message sent successfully' });
                console.log('SUCCESS!');
                setTimeout(() => {
                    window.location.reload(); // Reload the page after a delay
                }, 2000); // Optional: Delay to let the user see the success message
            },
            (error) => {
                setStatus({ success: false, message: 'Something went wrong, please try again later.' });
                console.log('FAILED...', error.text);
            }
        );
};

  
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      });
  }

  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  

  return (
    <section className="contact" id="connect">
     <Container className="contctform" >
  <Row className="align-items-center">
    <Col size={10} md={6}>
    <h3>Sharjah</h3>
          <div style={{color:"gray",listStyleType: 'none',fontSize:"14px"}}>
          <li >Phone:<a href="tel:+971 56 660 5705"style={{color:"#ce8e04"}}>+971 56 660 5705</a></li>
          <li >Email:<a href={"mailto:info@smartstonemarble.com" } style={{color:"#ce8e04"}}>info@smartstonemarble.com</a> or <a href={"mailto:info@smartstonemarble.com" } style={{color:"#ce8e04"}}>smartstonemarbles@gmail.com</a></li>
          <li >Address:<span >Al Sajaah Industriel Area 1000,Sharjah,UAE </span></li>


       </div>
       <br/>
      <div className="location-map" style={{ marginBottom: '40px' }}>
        <h2>Location Map</h2>
        
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d7213.591116742471!2d55.62967549693466!3d25.31107198146082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m0!4m5!1s0x3ef5f3004428bb43%3A0xbda282056f7f2a23!2s8J6Q%2BFX8%20Smartstone%20-%20Al%20Sajaah%20-%20Sharjah!3m2!1d25.311163699999998!2d55.639953399999996!5e0!3m2!1sen!2sae!4v1728988282958!5m2!1sen!2sae"
          width="500"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Smart Stone LLC Location"
        ></iframe>
        <p>
          <a
            href="https://maps.app.goo.gl/Z4DwDLi5yYaVHF8s9"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Directions
          </a>
        </p>
      </div>
    </Col>
    <Col size={12} md={6}>
      <div>
        <h2>Get In Touch</h2>
        <form ref={form} onSubmit={sendEmail}>
          <Row>
            <Col size={12} sm={6} className="px-1">
              <input
                type="text"
                name="from_name"
                value={formDetails.firstName}
                placeholder="First Name"
                onChange={(e) => onFormUpdate('firstName', e.target.value)}
              />
            </Col>
            <Col size={12} sm={6} className="px-1">
              <input
                type="text"
                value={formDetails.lastName}
                placeholder="Last Name"
                onChange={(e) => onFormUpdate('lastName', e.target.value)}
              />
            </Col>
            <Col size={12} sm={6} className="px-1">
              <input
                type="email"
                name="from_email"
                value={formDetails.email}
                placeholder="Email Address"
                onChange={(e) => onFormUpdate('email', e.target.value)}
              />
            </Col>
            <Col size={12} sm={6} className="px-1">
              <input
                type="tel"
                name="from_phone"
                value={formDetails.phone}
                placeholder="Phone No."
                onChange={(e) => onFormUpdate('phone', e.target.value)}
              />
            </Col>
            <Col size={12} className="px-1">
              <textarea
                rows="3"
                value={formDetails.message}
                name="message"
                placeholder="Message"
                onChange={(e) => onFormUpdate('message', e.target.value)}
              ></textarea>
              <button type="submit" value="Send"><span>{buttonText}</span></button>
            </Col>
            
          </Row>
        </form>
        {status.message && (
              <Col>
                <p className={status.success === false ? "danger" : "success"}>
                  {status.message}
                </p>
              </Col>
            )}
      </div>
    </Col>
  </Row>
</Container>

    </section>
  );
};
